<template lang="pug">
	.step
		.step__title
			|Укажите данные для получения полиса
		.step__list
			.step__item
				.step__item-right
					app-input(:input="schema.mail", @handleInput="handleInput", :field.sync="mail")
			.step__item
				.step__item-right
					app-input(:input="schema.phone", @handleInput="handleInput",:field.sync="phone")
			.step__item
				.step__item-right
					app-input(:input="schema.polisDate", @handleInput="handleInput",:field.sync="polisDate")
			.step__item
				.checkbox.checkbox_step4
					input.checkbox__control(type="checkbox", v-model="checkboxChecked", v-validate="{required: true}" @change="handleCheckboxChange" name="terms", id="checkbox-terms")
					label.checkbox__label(for="checkbox-terms")
						span.checkbox__icon
						span.checkbox__text-content
							|Соглашаюсь с 
							a.input-desc__link(href="https://zettains.ru/upload/rules/pravila-ns-ao-na-sayt.pdf" target="_blank")
								|правилами страхования 
				.checkbox.checkbox_step4
					input.checkbox__control(type="checkbox", v-model="checkboxChecked2", v-validate="{required: true}" @change="handleCheckboxChange" name="terms2", id="checkbox-terms2")
					label.checkbox__label(for="checkbox-terms2")
						span.checkbox__icon
						span.checkbox__text-content
							|Подтверждаю, что не отношусь к категории ИПДЛ/РПДЛ.	
				.checkbox.checkbox_step4
					input.checkbox__control(type="checkbox", v-model="checkboxChecked3", v-validate="{required: true}" @change="handleCheckboxChange" name="terms3", id="checkbox-terms3")
					label.checkbox__label(for="checkbox-terms3")
						span.checkbox__icon
						span.checkbox__text-content
							|Я являюсь владельцем платежной карты, с которой производится оплата страховой премии.	
				.checkbox.checkbox_step4
					input.checkbox__control(type="checkbox", v-model="checkboxPolicyChecked", v-validate="{required: true}" @change="handleCheckboxChange" name="policy", id="checkbox-policy")
					label.checkbox__label(for="checkbox-policy")
						span.checkbox__icon
						span.checkbox__text-content
							|Я даю 
							a.input-desc__link(href="https://zettains.ru/upload/rules/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5%20%D0%BE%D1%84%D0%BE%D1%80%D0%BC%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D0%B0%20%D0%90%D0%9E.pdf" target="_blank")
								|согласие 
							|на обработку персональных данных в соответствии с 
							a.input-desc__link(href="https://zettains.ru/company/privacy/" target="_blank")
								|политикой в отношении обработки персональных данных
		.step__desc
			|В страховку включены риски связанные с занятием любительским, профессиональным спортом или экстремальными видами спорта по всему миру.
		
		
</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
export default {

  name: 'app-step2',
  components: {
    AppInput,
  },
  data() {
  	return {
  		checkboxChecked:false,
		checkboxChecked2:false,
		checkboxChecked3:false,
		checkboxPolicyChecked:false
  	}
  },
  methods:{
		handleInput(e){
			this.checkButton();
			// setTimeout(() => {
			// 	if(this.phone.length && this.mail.length && this.polisDate.length && this.checkboxChecked && !this.$validator.errors.items.length) {
   //        this.buttonIsDisabled = false;
			// 	} else {
			// 		this.buttonIsDisabled = true
			// 	}
			// },0)
			
		},
		checkButton(){
			let {phone, mail, polisDate, checkboxChecked,checkboxChecked2,checkboxChecked3,checkboxPolicyChecked} = this;
			
			setTimeout(() => {
				if(phone.length && mail.length && polisDate.length && checkboxChecked && checkboxChecked2 && checkboxChecked3 &&checkboxPolicyChecked && !this.$validator.errors.items.length) {
          this.buttonIsDisabled = false;
          console.log('if')
				} else {
					console.log('else99')
					this.buttonIsDisabled = true
				}
			},0)
		},
		handleCheckboxChange(){
			this.checkButton();
			// setTimeout(() => {
			// 	if(this.phone.length && this.mail.length && this.polisDate.length && this.checkboxChecked && !this.$validator.errors.items.length) {
   //        this.buttonIsDisabled = false;
			// 	} else {
			// 		this.buttonIsDisabled = true
			// 	}
			// },0)
		},
		handleClickPrev(){
			this.$router.push({name:'step3'})
		}
  },
  computed:{
  	...mapFields([
      'phone',
      'mail',
      'polisDate',
      'buttonIsDisabled'
    ]),
    ...mapGetters({
		  schema: 'getSchema',
		  // popupIsActive: 'PopupIsActive'
		}),
		// checkButton(){
		// 	console.log(123)
		// 	if(this.phone.length && this.mail.length && this.polisDate.length){
		// 		this.buttonIsDisabled = false;
		// 		return true
		// 	}
		// }
  },
  watch: {
  	// phone(val) {
  	// 	console.log(val)
  	// }
  }
}
</script>

<style lang="scss">
	
	
</style>